import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { connect } from "lib/core/store"
import AssessmentWrapper from "library/show/components/content/assessment/AssessmentWrapper"
import PropTypes from "prop-types"
import { useEffect } from "react"

const AssessmentSubmissionPreview = ({
  stepId,
  contentId,
  userId,
  loading,
  assessment,
  loadAssessment
}) => {
  useEffect(() => {
    loadAssessment(stepId, contentId, userId)
  }, [stepId, contentId, userId])

  if (loading) {
    return <LoadingCircle />
  }

  if (assessment) {
    return <AssessmentWrapper assessment={assessment} isReview />
  }

  return null
}

AssessmentSubmissionPreview.displayName = "AssessmentSubmissionPreview"

AssessmentSubmissionPreview.propTypes = {
  stepId: PropTypes.number.isRequired,
  contentId: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired
}

export default connect(
  AssessmentSubmissionPreview,
  "stepCompletion",
  (state, ownProps) => {
    const store = state.stepCompletionStore
    const assessment = store.state.assessment_for_review
    const loading = store.state.assessment_for_review_loading || !assessment
    const loadAssessment = store.action.loadAssessmentForReview
    return {
      ...ownProps,
      loading,
      assessment,
      loadAssessment
    }
  },
  ["assessment_for_review", "assessment_for_review_loading"]
)
